import en from './en.js';

export default en;
